import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const VirtualTransactionsDownload2ModalUI = ({
  context, successMsg, errorList, setErrorList,
  // modes
  downloadMode, submitted, bankAccountNumber,
  // event handlers
  onSubmit, onCancelClick,
  //
  format, onFormatChange, formatError, setFormatError, formatList,
  //
  fromYear, onFromYearChange, fromYearError, setFromYearError, fromYearList,
  //
  fromMonth, onFromMonthChange, fromMonthError, setFromMonthError, fromMonthList,
  //
  toYear, onToYearChange, toYearError, setToYearError, toYearList,
  //
  toMonth, onToMonthChange, toMonthError, setToMonthError, toMonthList
}) =>
  <ModalFormUI
    context={context}
    titleLabel={bankAccountNumber}
    buttonLabel='Download'
    cancelLabel='Cancel'
    isOpen={downloadMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >

    <InputSelectSF type='select' name='format' label='Format'
      value={format} onChange={onFormatChange} optionList={formatList}
      error={formatError} setError={setFormatError}
    />
    <div className='g_flex_h g_flex_top g_m_top_50'>
      <div className='g_m_right_100' style={{ width: '200px' }}>
        <InputSelectSF type='select' name='fromYear' label='Year'
          value={fromYear} onChange={onFromYearChange} optionList={fromYearList}
          error={fromYearError} setError={setFromYearError}
        />
      </div>
      <div className='g_m_top_200 g_m_right_100'>From</div>
      <div style={{ width: '200px' }}>
        <InputSelectSF type='select' name='fromMonth' label='Month'
          value={fromMonth} onChange={onFromMonthChange} optionList={fromMonthList}
          error={fromMonthError} setError={setFromMonthError}
        />
      </div>
    </div>
    <div className='g_flex_h g_flex_top g_m_top_50'>
      <div className='g_m_right_100' style={{ width: '200px' }}>
        <InputSelectSF type='select' name='toYear' label='Year'
          value={toYear} onChange={onToYearChange} optionList={toYearList}
          error={toYearError} setError={setToYearError}
        />
      </div>
      <div className='g_m_top_200 g_m_right_100'>To</div>
      <div style={{ width: '200px' }}>
        <InputSelectSF type='select' name='toMonth' label='Month'
          value={toMonth} onChange={onToMonthChange} optionList={toMonthList}
          error={toMonthError} setError={setToMonthError}
        />
      </div>
    </div>
  </ModalFormUI>

export default VirtualTransactionsDownload2ModalUI
